import lodash from "lodash";
import { CALL_API, actionTypes, states } from "./constants";

export const RESET_CALL_API = "RESET_CALL_API";

export const apiCall = (endpoint, payload, schema, options, actions) => ({
	[CALL_API]: {
		endpoint,
		payload,
		schema,
		options,
		actions
	}
});

export const apiCallUpdate = (
	requestActionType,
	currentActionType,
	requestStatus
) => {
	const metadata = states[requestStatus];
	return {
		meta: {
			[CALL_API]: {
				requestActionType,
				currentActionType,
				...metadata,
				requestStatus
			}
		}
	};
};

export const apiCallAction = (action, requestActionType, requestStatus) => {
	return lodash.merge(
		action,
		apiCallUpdate(requestActionType, action.type, requestStatus)
	);
};

export const apiReset = () => {
	return {
		type: RESET_CALL_API
	};
};
